export const GA_ID_BRANDSITE = process.env.NEXT_PUBLIC_TEST === 'production' ? 'G-0C4P8XM2QT' : 'G-KW7EMZBBYT';
export const GA_ID_WEBVIEW = 'G-2T16RVWL4Z';
